import { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";
import { RenewDialog } from "@/components/RenewDialog";

export const RenewalRequests = ({ onChange }) => {
  const [list, setList] = useState([]);
  const [renewing, setRenewing] = useState(null);
  const load = () => api.get("/supporters/renewal-requests").then((r) => setList(r.data)).catch((e) => logError("Renewal requests failed:", e));
  useEffect(() => { load(); }, []);

  const act = async (r, path, msg) => {
    try { await api.post(`/supporters/${r.id}/${path}`); toast.success(msg); setList((l) => l.filter((x) => x.id !== r.id)); onChange?.(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (!list.length) return null;
  return (
    <div className="space-y-3 mb-6" data-testid="renewal-requests">
      {list.map((r) => (
        <div key={r.id} className="mm-card p-5 border-l-4 border-mm-primary flex flex-wrap items-center gap-4" data-testid={`renewal-request-${r.id}`}>
          <div className="w-10 h-10 rounded-2xl bg-mm-primary/10 text-mm-primary flex items-center justify-center shrink-0"><KeyRound size={18} /></div>
          <div className="flex-1 min-w-[180px]">
            <div className="font-semibold">{r.name} asked to renew their link</div>
            <div className="text-sm text-mm-muted">{r.expired ? "Their link has expired." : "Their link expires soon."} Renewing keeps the same link for 90 more days.</div>
          </div>
          <div className="flex gap-2">
            <button className="mm-btn !py-2 !px-4 text-sm" onClick={() => setRenewing(r)} data-testid={`renewal-renew-${r.id}`}>Renew for 90 days</button>
            <button className="mm-btn-ghost !py-2 !px-4 text-sm" onClick={() => act(r, "renewal-request/dismiss", "Request dismissed")} data-testid={`renewal-dismiss-${r.id}`}>Dismiss</button>
          </div>
        </div>
      ))}
      <RenewDialog supporter={renewing} onClose={() => setRenewing(null)} onDone={() => { setList((l) => l.filter((x) => x.id !== renewing?.id)); onChange?.(); }} />
    </div>
  );
};
